import { cn } from 'lib/helpers/utility';

import DocText from '../DocText';
import { DOC_TEXT } from '../lib/docStyles';

const DocSectionBanner = ({ title, subtitle, className }) => (
  <div
    className={cn('border border-solid border-neutral-300 bg-neutral-100 px-2.5 py-2', className)}>
    <DocText size="xs" className={DOC_TEXT.bannerTitle}>
      {title}
    </DocText>
    {subtitle && (
      <DocText size="xs" className={DOC_TEXT.bannerSubtitle}>
        {subtitle}
      </DocText>
    )}
  </div>
);

export default DocSectionBanner;
